import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SettingsCard from './SettingsCard'
import PricesList from './PricesList'
import CouponsList from './CouponsList'

const AccessCard = ({ certification }) => {
  const { t } = useTranslation()

  return (
    <SettingsCard eyebrow={t('certificationBuilder.details.access')}>
      <PricesList certification={certification} />
      <CouponsList certification={certification} />
    </SettingsCard>
  )
}

AccessCard.propTypes = {
  certification: PropTypes.object.isRequired,
}

export default AccessCard
